module.exports = __webpack_public_path__ + "static/media/yellow-bold-right-arrow.5b72c3df.svg";